"use client";

import { useEffect } from "react";
import { CONSENT_CHANGE_EVENT, readChoice, type ConsentChoice } from "@/lib/consent";
import { SITE } from "@/site";

// Ahrefs Web Analytics project key (app.ahrefs.com → project settings → Web Analytics)
const AHREFS_KEY = SITE.ahrefsKey ?? "";
const SCRIPT_SRC = "https://analytics.ahrefs.com/analytics.js";

function loadAhrefs() {
  if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return;
  const script = document.createElement("script");
  script.src = SCRIPT_SRC;
  script.async = true;
  script.dataset.key = AHREFS_KEY;
  document.head.appendChild(script);
}

// Ahrefs Web Analytics sets no cookies, but it still sends page views, so it shares the
// Analytics consent with GA4: without consent the script is never requested. Once loaded it
// has no off switch (it patches history.pushState), so a withdrawn consent reloads the page.
export function AhrefsAnalytics() {
  useEffect(() => {
    if (!AHREFS_KEY) return;
    if (readChoice()?.a === 1) loadAhrefs();

    function onConsentChange(event: Event) {
      const granted = (event as CustomEvent<ConsentChoice>).detail?.a === 1;
      if (granted) loadAhrefs();
      else if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) window.location.reload();
    }

    window.addEventListener(CONSENT_CHANGE_EVENT, onConsentChange);
    return () => window.removeEventListener(CONSENT_CHANGE_EVENT, onConsentChange);
  }, []);

  return null;
}
